import { render, staticRenderFns } from "./header.component.vue?vue&type=template&id=6b5823af"
import script from "./header.component.ts?vue&type=script&lang=ts&external"
export * from "./header.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports